export default class DuplicateShopItem {
	constructor(item) {
		if (item === undefined) {
			this.Id = "";
			this.ShopperId = "";
			this.Status = "";
		}
		else {
			this.initialize(item);
		}
	}

	async initialize(item) {
		this.Id = item.id;
		this.ShopperId = item.shopperId;
		this.Status = item.status;
	}
}